import { Button } from '@chakra-ui/react'

import { Search } from '../../images/Search'

interface SearchButtonProps {
  isOpen: boolean
  toggleOpen?: () => void
}

export const SearchButton = ({ isOpen, toggleOpen }: SearchButtonProps) => {
  return (
    <Button onClick={toggleOpen}>
      <Search />
      {isOpen ? 'Skrýt vyhledávání' : 'Vyhledávání'}
    </Button>
  )
}
